import * as TK from 'components/post/PostFeedPreview/translations/constants';
import { Translations } from 'translations/types';

export const postFeedPreviewEnUsLocale: Translations = {
  [TK.POST_FEED_PREVIEW_BUTTON_LABEL]: 'Read More',
};
